import { url } from "./misc";
import Cookies from 'js-cookie';

export async function DeployPSE(tenant, is_destroy, message, server_type, location, deploy_dns, dns_record_value, pse_count) {
    const endpoint = url + "/api/terraform/run"
    const JWT = Cookies.get('CF_Authorization');

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'Tenant': tenant,
            "Message": message,
            "ServerType": server_type,
            "IsDestroy": is_destroy,
            "Location": location,
            "DeployDNS": deploy_dns,
            "RecordValue": dns_record_value,
            "PSECount": pse_count
        }
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response
};

export async function RunStatus(run_id) {
    const endpoint = url + "/api/terraform/status"
    const JWT = Cookies.get('CF_Authorization');

    // Create the request options
    const requestOptions = {
        method: 'POST',
        headers: {
            'JWT': JWT,
            'RunID': run_id
        }
    };

    // Make the HTTP request
    const response = await fetch(endpoint, requestOptions);
    return response
};